import axios from 'axios';

const state = {
  offers: [],
  isLoading: false,              // ← у вас использовалось, но не было в state
  addKpModal: false, // Modal visibility state for Add Invoice
  addInvoiceModal: false, // Modal visibility state for Add Invoice
  invoiceData: null, // Placeholder for any initial data
  offerDetails: null, // Store the fetched offer details
  currentOffer: null, // Store the current clicked tirage
  totalOffers: 0,
  selectedOffer: null, // Store the selected offer for the modal
  showPaymentModal: false, // Control the payment modal visibility
  selectedOfferId: null,
  isOfferDeliveryModalOpen: false,
  currentBooks: [],
  currentOfferId: null, 
  booksModal: false,
  multiPreviewOffers: [],
};

const getters = {
  multiPreviewOffers: (s) => s.multiPreviewOffers,
  offers: (state) => state.offers,
  isLoading: (state) => state.isLoading,
  addKpModal: (state) => state.addKpModal,
  addInvoiceModal: (state) => state.addInvoiceModal,
  invoiceData: (state) => state.invoiceData, // Getter for invoice data if needed
  offerDetails: (state) => state.offerDetails || {},
  currentOffer: (state) => state.currentOffer,
  selectedOffer: (state) => state.selectedOffer,
  showPaymentModal: (state) => state.showPaymentModal,
  selectedOfferId: state => state.selectedOfferId,
   allOffers(state) {
      return state.offers;
    },

  currentBooks: (state) => state.currentBooks || [],
  isBooksModalOpen: (state) => state.booksModal === true,
  currentOfferId: (state) => state.currentOfferId,
};

const mutations = {
  SET_MULTI_PREVIEW_OFFERS(state, offers) {
    state.multiPreviewOffers = offers || []
  },
  SET_FLAG(state, { id, key, value }) {
    const list = state.offers || state.items || []
    const idx = list.findIndex(o => o.id === id)
    if (idx !== -1) {
      // учитывая, что в таблице мы читаем эти же названия полей
      list[idx][key] = value
    }
  },
  removeOffer(state, offerId) {
    state.offers = state.offers.filter(offer => offer.id !== offerId);
  },
    setCurrentBooks(state, items) {
    state.currentBooks = items;
  },
  setBooksModal(state, status) {
    state.booksModal = status;
  },
    setCurrentOfferId(state, id) {
    state.currentOfferId = id;
  },
  openOfferDeliveryModal(state, offer) {
    state.selectedOffer = offer;
    state.selectedOfferId = offer.id;
    state.isOfferDeliveryModalOpen = true;
  },
  closeOfferDeliveryModal(state) {
    state.selectedOffer = null;
    state.selectedOfferId = null;
    state.isOfferDeliveryModalOpen = false;
  },
  SET_OFFERS(state, offers) {
    state.offers = offers;
  },
  SET_TOTAL_OFFERS(state, total) {
    state.totalOffers = total;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ADD_KP_MODAL(state, status) {
    state.addKpModal = status; // Toggle modal visibility
  },
  SET_ADD_INVOICE_MODAL(state, status) {
    state.addInvoiceModal = status; // Toggle Invoice modal visibility
  },
  SET_INVOICE_DATA(state, data) {
    state.invoiceData = data; // Set invoice data if needed
  },
  CLOSE_ADD_KP_MODAL(state) {
    state.addKpModal = false;
    state.invoiceData = null; // Clear invoice data when closing
  },
  CLOSE_ADD_INVOICE_MODAL(state) {
    state.addInvoiceModal = false;
    state.invoiceData = null; // Clear invoice data when closing Invoice modal
  },
  SET_OFFER_DETAILS(state, offer) {
    state.offerDetails = offer; // Set the offer details
  },
  SET_CURRENT_OFFER(state, offer) {
    state.currentOffer = offer; // Set the clicked tirage
  },
  SET_SELECTED_OFFER(state, offer) {
    state.selectedOffer = offer;
  },
  SET_SHOW_PAYMENT_MODAL(state, status) {
    state.showPaymentModal = status;
  },
};

// --- helpers for status search mapping ---
const RAW_STATUSES = [
  'in process',
  'accept',
  'rejected',
  'Request for invoice',
  'Invoice and contract sent',
  'typo_finish',
  'stock',
  'wap',
  'done',
  'archieve', // текущее написание в БД
];

const normalize = (s) => (s ?? '').toString().toLowerCase().trim();

// Базовые алиасы без i18n (хватает для поиска)
const STATUS_ALIASES = {
  'в работе': 'in process',
  'работа': 'in process',
  'принят': 'accept',
  'отклонен': 'rejected',
  'запрос счета': 'Request for invoice',
  'счет и договор отправлены': 'Invoice and contract sent',
  'типография завершена': 'typo_finish',
  'склад': 'stock',
  'ожидание оплаты': 'wap',
  'сдан': 'done',
  'архив': 'archieve',
  'archive': 'archieve',
};

function toRawStatusIfAny(input) {
  const q = normalize(input);
  if (!q) return null;

  // точное совпадение с "raw"
  const exactRaw = RAW_STATUSES.find((k) => normalize(k) === q);
  if (exactRaw) return exactRaw;

  // точное совпадение с алиасом
  for (const [alias, raw] of Object.entries(STATUS_ALIASES)) {
    if (normalize(alias) === q) return raw;
  }

  // частичное совпадение
  for (const raw of RAW_STATUSES) {
    if (normalize(raw).includes(q)) return raw;
  }
  for (const [alias, raw] of Object.entries(STATUS_ALIASES)) {
    if (normalize(alias).includes(q) || q.includes(normalize(alias))) return raw;
  }

  return null;
}

function buildOfferParams(base = {}) {
  const params = { per_page: 50, sort_by: 'created_at', sort_dir: 'desc', ...base };
  if (params.search && params.search.toString().trim()) {
    const raw = toRawStatusIfAny(params.search);
    if (raw) params.search = raw;
  }
  return params;
}


const actions = {
  async fetchOffersDetailsBatch({ commit }, ids) {
    const token = localStorage.getItem('token')

    const { data } = await axios.post(
      'https://apidash.smartpress.kz/api/offers/details-batch',
      { ids },
      { headers: { Authorization: `Bearer ${token}` } }
    )

    // ожидаем data.offers = [{...full offer with items.work_types...}]
    commit('SET_MULTI_PREVIEW_OFFERS', data.offers)
  },
 async fetchOffersPaginated({ commit }, { page = 1, per_page = 50, search = '', sort_by = 'created_at', sort_dir = 'desc' }) {
  commit('SET_LOADING', true);
  try {
    const token = localStorage.getItem('token');
    const params = buildOfferParams({ page, per_page, search, sort_by, sort_dir });

    const response = await axios.get(`https://apidash.smartpress.kz/api/offers`, {
      headers: { Authorization: `Bearer ${token}` },
      params
    });

    commit('SET_OFFERS', response.data.data);
    commit('SET_TOTAL_OFFERS', response.data.total);
  } catch (error) {
    console.error('Error fetching offers:', error);
  } finally {
    commit('SET_LOADING', false);
  }
},
  async fetchOffers({ commit }) {
    commit('SET_LOADING', true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('https://apidash.smartpress.kz/api/offers-kanban', {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      commit('SET_OFFERS', response.data.offers);
      commit('SET_TOTAL_OFFERS', response.data.offers.length); // Set total offers
    } catch (error) {
      console.error('Error fetching tirages:', error);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async toggleFlag({ commit }, { id, key, value }) {
    const token = localStorage.getItem('token')
    // если в UI ключи приходят «apiKey» вида isbn/contract_file — маппим к bool-полю
    const keyMap = {
      isbn: 'has_isbn',
      contract_file: 'has_contract',
      invoice_file: 'has_invoice',
      act_file: 'has_act',
      esf_file: 'has_esf',
      author_contract_file: 'has_author_contract',
      author_copies: 'has_author_copies',
      sales_contract_file: 'has_sales_contract',
      in_price: 'in_price',
      in_store: 'in_store',
    }
    const dbKey = keyMap[key] || key

    // optimistic
    commit('SET_FLAG', { id, key: dbKey, value })

    try {
      await axios.patch(
        `https://apidash.smartpress.kz/api/offers/${id}/toggle-flag`,
        { key: dbKey, value },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      // при желании — перезагрузить страницу/карточку
      // dispatch('fetchOffersPaginated', currentParams)
    } catch (e) {
      // откат при ошибке
      commit('SET_FLAG', { id, key: dbKey, value: !value })
      throw e
    }
  },
  async openOfferDeliveryModal({ commit, dispatch }, offerId) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`https://apidash.smartpress.kz/api/offers/${offerId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      commit('openOfferDeliveryModal', response.data); // сюда попадёт полный объект
    } catch (error) {
      console.error('Failed to fetch offer for delivery modal:', error);
    }
  },
  openPaymentModal({ commit }, offer) {
    if (offer && offer.id) {
      console.log("Opening modal with offer ID:", offer.id); // Debug log to ensure offer is passed correctly
      commit("SET_SELECTED_OFFER", offer);
      commit("SET_SHOW_PAYMENT_MODAL", true);
    } else {
      console.error("Offer is undefined or missing ID:", offer); // Debug error if no offer or ID
    }
  },
  closePaymentModal({ commit }) {
    commit("SET_SHOW_PAYMENT_MODAL", false); // Закрыть модальное окно
    commit("SET_SELECTED_OFFER", null); // Очистить выбранное предложение
  },
 openKPModal({ commit }, offerData) {
  // Мы предполагаем, что offerData уже содержит role_id
  commit('SET_CURRENT_OFFER', offerData);
  commit('SET_ADD_KP_MODAL', true);
},
  openInvoiceModal({ commit }, offerData) {
    commit('SET_CURRENT_OFFER', offerData); // Pass the offer data to the modal
    commit('SET_ADD_INVOICE_MODAL', true); // Show Invoice modal
  },
  closeKpModal({ commit }) {
    commit('CLOSE_ADD_KP_MODAL'); // Close modal
  },
  closeInvoiceModal({ commit }) {
    commit('CLOSE_ADD_INVOICE_MODAL'); // Close Invoice modal
  },
  async createOffer({ commit }, invoiceData) {
    try {
      const token = localStorage.getItem('token'); // Use token for authentication
      const response = await axios.post(
        'https://apidash.smartpress.kz/api/offers', // Replace with your API endpoint
        invoiceData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json', // Ensure correct content type
          },
        }
      );
      console.log('Offer created:', response.data);

      // Optionally, you can fetch updated data or show a success notification here
    } catch (error) {
      console.error('Error creating offer:', error);
      throw error; // Re-throw the error to handle in the component if needed
    }
  },

  async fetchOfferDetails({ commit }, offerId) {
    commit('SET_LOADING', true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`https://apidash.smartpress.kz/api/offers/${offerId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      commit('SET_OFFER_DETAILS', response.data);
    } catch (error) {
      console.error('Error fetching offer details:', error);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async updateOffer({ dispatch }, offerData) {
    try {
      const token = localStorage.getItem('token');
      const offerId = offerData.get('offer_id'); // Access the offer ID from FormData
  
      // Send POST request to update the offer
      const response = await axios.post(
        `https://apidash.smartpress.kz/api/offers/${offerId}`,
        offerData, 
        {
          headers: {
            'Authorization': `Bearer ${token}`, // No need to manually set 'Content-Type'
          },
        }
      );
      
      console.log('Offer updated:', response.data);
      // commit("SET_SELECTED_OFFER", null); // Clear selected offer after update
        await dispatch('fetchOffersPaginated', {
          page: 1,
          per_page: 50,
          search: '',
          sort_by: 'created_at',
          sort_dir: 'desc',
        });   
       } catch (error) {
      console.error('Error updating offer:', error);
      throw error;
    }
  },
   async updateInvoice({ dispatch }, offerData) {
    try {
      const token = localStorage.getItem('token');
      const offerId = offerData.get('offer_id'); // Access the offer ID from FormData
  
      // Send POST request to update the offer
      const response = await axios.post(
        `https://apidash.smartpress.kz/api/offers/${offerId}/invoice`,
        offerData, 
        {
          headers: {
            'Authorization': `Bearer ${token}`, // No need to manually set 'Content-Type'
          },
        }
      );
      
      console.log('Offer updated:', response.data);
      // commit("SET_SELECTED_OFFER", null); // Clear selected offer after update
        await dispatch('fetchOffersPaginated', {
          page: 1,
          per_page: 50,
          search: '',
          sort_by: 'created_at',
          sort_dir: 'desc',
        });   
       } catch (error) {
      console.error('Error updating offer:', error);
      throw error;
    }
  },
  async deleteOffer({ commit }, offerId) {
      const token = localStorage.getItem('token');
      await axios.delete(`https://apidash.smartpress.kz/api/offers/${offerId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      commit('removeOffer', offerId);
    },
    async copyOffer({ dispatch }, offerId) {
      const token = localStorage.getItem('token');
      await axios.post(`https://apidash.smartpress.kz/api/offers/${offerId}/copy`, null, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      // Обновим список офферов
      await dispatch('fetchOffers');
    },

  async updateOfferInvoice({ dispatch }, invoiceData) {
    try {
      const token = localStorage.getItem('token');
  
      // Check if token is not null or empty
      if (!token) {
        throw new Error('Token is missing. Please login again.');
      }
  
      // Make the API call to update the invoice
      const response = await axios.post(
        `https://apidash.smartpress.kz/api/offers/${invoiceData.offerId}/update-invoice`, // Adjust the API endpoint accordingly
        invoiceData,  // Payload can be empty if you're just updating the status
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
  
      console.log('Invoice updated:', response.data);
  
      // Optionally, dispatch another action to refresh the offers list
      await dispatch('fetchOffers'); 
  
    } catch (error) {
      console.error('Error updating invoice:', error);
      throw error; // Re-throw the error to handle in the component if needed
    }
  },
  async saveInvoice({ commit, state }, { offer_id, progress }) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`https://apidash.smartpress.kz/api/invoices/${offer_id}/update-progress`, {
        progress,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      // Find the offer in the state and update it with the new progress
      const updatedOffers = state.offers.map(offer => 
        offer.id === offer_id ? { ...offer, progress } : offer
      );
      
      // Commit the updated offers list to the state
      commit('SET_OFFERS', updatedOffers);
      
    } catch (error) {
      console.error('Error updating progress:', error);
    }
  },
  openBooksModal({ commit }, offer) {
    if (!offer || !offer.id) return;
    commit('setCurrentOfferId', offer.id);
    // глубокая копия, чтобы не мутировать исходный массив
    const items = JSON.parse(JSON.stringify(offer.items || []));
    commit('setCurrentBooks', items);
    commit('setBooksModal', true);
  },
   async updateOfferItems({ dispatch }, { offerId, items }) {
    if (!offerId) throw new Error('offerId is required');
    const token = localStorage.getItem('token');
    await axios.patch(`https://apidash.smartpress.kz/api/offers/${offerId}/items`, { items }, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Обновляем канбан после сохранения, чтобы увидеть price_changed и новые суммы
    await dispatch('fetchOffers');
  },
  
 
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
